import { NgModule, Injectable } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

import { Observable } from 'rxjs';

import { CoreDialogModule } from '../core/core.module';
import { ScreenSizeService } from '../core/core';

import { MessageBoxDialogComponent, MessageBoxDialogOptions } from './messagebox.dialogcomponent';

@Injectable()
export class MessageBoxDialogService {
    smallMediaSize: boolean;

    constructor(private matDialog: MatDialog, private mediaChange: ScreenSizeService) {
        this.smallMediaSize = this.mediaChange?.ScreenSize?.IsSmallDisplay || false;
    }

    // #region Close All Dialogs Service Call

    CloseAllDialogs(): void {
        this.matDialog.closeAll();
    }

    // #endregion

    // #region Open

    Open(options?: MessageBoxDialogOptions): Observable<boolean> {
        const self = this;
        const dlgoptions: MessageBoxDialogOptions = {
            disableClose: true,
            data: {
                TitleText: 'Information',
                MessageText: '',
                OKText: 'OK',
                ...options,
            },
            maxHeight: '85vh',
            width: options?.width || '80vw',
        };

        if (self.smallMediaSize) {
            dlgoptions.panelClass = ['dialog-not-100', 'smalldialogpanel'];
        } else {
            dlgoptions.panelClass = 'dialog-not-100';
        }

        const openHandle = this.matDialog.open<MessageBoxDialogComponent>(MessageBoxDialogComponent, dlgoptions);

        return openHandle.afterClosed();
    }

    // #endregion
}

@NgModule({
    imports: [CoreDialogModule, MatButtonModule, MatDialogModule],
    declarations: [MessageBoxDialogComponent],
    exports: [MessageBoxDialogComponent],
    providers: [MessageBoxDialogService],
})
export class MessageBoxDialogModule {}
